import React from "react";

// Scrolling marquee strip for urgency
export default function UrgencyStrip() {
  const items = [
    "GUINCHO 24 HORAS",
    "COBRIMOS QUALQUER ORÇAMENTO",
    "MENOR PREÇO DA REGIÃO",
    "ATENDIMENTO IMEDIATO",
    "SOCORRO MECÂNICO",
    "REMOÇÃO DE VEÍCULOS",
  ];
  const loop = [...items, ...items, ...items];

  return (
    <div
      data-testid="urgency-strip"
      className="bg-[#E50914] border-y-4 border-black overflow-hidden relative py-3"
    >
      <div className="flex whitespace-nowrap marquee">
        {loop.map((t, i) => (
          <span key={i} className="font-anton text-lg md:text-2xl uppercase text-white px-6 tracking-wider">
            {t} <span className="text-black mx-4">★</span>
          </span>
        ))}
      </div>
    </div>
  );
}
